import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import {
  TalanaEmployee,
  TalanaEmployeeDetail,
  TalanaResponse,
  TalanaPaginatedData,
} from 'app/shared';

@Injectable({
  providedIn: 'root',
})
export class TalanaService {
  private http = inject(HttpClient);

  getEmployees(search: string, page: number, limit: number, sortBy?: string, sortOrder?: string) {
    const params: Record<string, string> = {
      search,
      page: page.toString(),
      limit: limit.toString(),
    };
    if (sortBy) params['sortBy'] = sortBy;
    if (sortOrder) params['sortOrder'] = sortOrder;
    return this.http.get<TalanaResponse<TalanaPaginatedData<TalanaEmployee>>>(
      `${environment.apiUrl}/v1/empleados`,
      { params },
    );
  }

  getEmployeeById(id: string) {
    return this.http.get<TalanaResponse<TalanaEmployeeDetail>>(
      `${environment.apiUrl}/v1/empleados/${id}`,
    );
  }

  syncEmployees() {
    return this.http.get(`${environment.apiUrl}/v1/empleados/talana/sincronizacion`);
  }
}
